<template>
  <router-link v-if="link" class="back-link" :to="link">
    <span ref="link"> <back-arrow /> {{ label }} </span>
  </router-link>
  <ui-button type="secondary" v-else class="back-link">
    <back-arrow /> {{ label }}
  </ui-button>
</template>
<script>
import BackArrow from "@/components/svg/arrow-back";
import { UiButton } from "keen-ui";
export default {
  props: ["link", "label"],
  components: {
    BackArrow,
    UiButton
  }
};
</script>
<style lang="scss" scoped>
.back-link {
  position: relative;
  display: inline-flex;
  text-decoration: none;
  color: #666;
  text-transform: uppercase;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  font-size: 14px;
  letter-spacing: 0.75px;
  span {
    display: flex;
    align-items: center;
  }
  &:hover {
    color: #000;
  }
  svg {
    width: 15px;
  }
}
</style>
